import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Add this block - declare missing variables and functions
  const user = null; // or get from context/props if available
  const subscription = null; // or get from context/props if available
  const handleSignOut = () => {
    // Implement sign out logic or get from context/props
    console.log('Sign out clicked');
  };

  const navItems = [
    { label: 'Dashboard', path: '/dashboard-overview', icon: 'LayoutDashboard' },
    { label: 'Catálogo', path: '/product-catalog-manager', icon: 'Package' },
    { label: 'Importar CSV', path: '/csv-import-dashboard', icon: 'Upload' },
    { label: 'Monitoramento', path: '/real-time-monitoring-dashboard', icon: 'Activity' },
    { label: 'Conect IA', path: '/ai-assistant-hub', icon: 'Sparkles' },
    { label: 'Insights IA', path: '/ai-insights', icon: 'TrendingUp' }
  ];

  const isActive = (path) => location?.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-14 items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
            <img 
              src="/assets/images/Captura_de_tela_2026-02-06_014642-1770355644537.png" 
              alt="VERTEX COMMERCE Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="font-bold text-lg text-foreground hidden sm:inline">VERTEX COMMERCE</span>
          </div>

          {/* Desktop Pill-Style Navigation */}
          <nav className="hidden md:flex items-center gap-2 bg-white rounded-full shadow-lg p-1.5">
            {navItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => navigate(item?.path)}
                className={`
                  flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300
                  ${
                    isActive(item?.path)
                      ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30 scale-105'
                      : 'bg-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }
                `}
              >
                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-md hover:bg-muted"
          >
            <Icon name={mobileMenuOpen ? 'X' : 'Menu'} size={24} className="text-foreground" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-border">
            {navItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => {
                  navigate(item?.path);
                  setMobileMenuOpen(false);
                }}
                className={`
                  w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-smooth
                  ${
                    isActive(item?.path)
                      ? 'bg-primary/10 text-primary border-l-4 border-primary' :'text-muted-foreground hover:bg-muted'
                  }
                `}
              >
                <Icon name={item?.icon} size={18} />
                <span>{item?.label}</span>
              </button>
            ))}
            {user && (
              <>
                <div className="border-t border-border my-2"></div>
                {subscription && (
                  <button
                    onClick={() => {
                      navigate('/my-subscription');
                      setMobileMenuOpen(false);
                    }}
                    className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-blue-600 hover:bg-blue-50"
                  >
                    <Icon name="CreditCard" size={18} />
                    <span>Minha Assinatura</span>
                  </button>
                )}
                <button
                  onClick={() => {
                    handleSignOut();
                    setMobileMenuOpen(false);
                  }}
                  className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-red-600 hover:bg-red-50"
                >
                  <Icon name="LogOut" size={18} />
                  <span>Sair</span>
                </button>
              </>
            )}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;